import { wrap } from '@motionone/utils';
import {
  motion,
  useAnimationFrame,
  useMotionValue,
  useTransform,
} from 'framer-motion';
import React, { useRef } from 'react';

import RichText from 'components/RichText/RichText';

import * as S from './ParallaxTitle.styles';
export interface ParallaxTitleProps {
  text: string;
  baseVelocity: number;
  length: number; // number of repetition for the text to match more than 100% of the screen
}

const defaultProps: Partial<ParallaxTitleProps> = {
  baseVelocity: 1,
  length: 4,
};

const ParallaxTitle: React.FunctionComponent<ParallaxTitleProps> = ({
  text,
  // baseVelocity,
  length,
  ...rest
}) => {
  const baseX = useMotionValue(0);

  const x = useTransform(baseX, v => `${wrap(-20, -20 - 100 / length, v)}%`);

  const directionFactor = useRef<number>(1);
  // @ts-ignore
  useAnimationFrame((t, delta) => {
    let moveBy = directionFactor.current * (delta / 1000);

    moveBy += directionFactor.current * moveBy;
    baseX.set(baseX.get() - moveBy);
  });

  return (
    <S.ParallaxTitleWrapper {...rest}>
      <motion.div className="scroller" style={{ x }}>
        <RichText as="span" size="display" richText={text} defaultFormatting />
        <RichText as="span" size="display" richText={text} defaultFormatting />
        <RichText as="span" size="display" richText={text} defaultFormatting />
        <RichText as="span" size="display" richText={text} defaultFormatting />
      </motion.div>
    </S.ParallaxTitleWrapper>
  );
};

ParallaxTitle.defaultProps = defaultProps;

export default ParallaxTitle;
